import type { SVGProps } from "react";
import * as React from "react";
const SvgGitFork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 6a3 3 0 1 1 4 2.83V9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-.17a3.001 3.001 0 1 1 2 0V9a4 4 0 0 1-4 4h-2v2.17a3.001 3.001 0 1 1-2 0V13H9a4 4 0 0 1-4-4v-.17A3.001 3.001 0 0 1 3 6Zm15-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-6 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
    />
  </svg>
);
export default SvgGitFork;
